var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "17", height: "17", viewBox: "0 0 17 17", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "g",
      { fill: "none", fillRule: "evenodd" },
      React.createElement("circle", { stroke: "#B8B8B8", strokeWidth: "1.8", cx: "8.5", cy: "8.5", r: "7.6" }),
      React.createElement(
        "g",
        { transform: "translate(7 3)" },
        React.createElement("path", { stroke: "#B8B8B8", strokeWidth: "2.5", strokeLinecap: "round", strokeLinejoin: "round", d: "M1.5 4.7v5" }),
        React.createElement("circle", { fill: "#B8B8B8", cx: "1.4", cy: "1.4", r: "1.4" })
      )
    )
  );
});